module.exports = __webpack_public_path__ + "img/pic.d87117cd.png";